import Const from 'const';
import ResolvingProcessDataDto from 'services/lineup-resolver/resolving-process-data-dto';

interface LineupResolvingPrecess {
    getProcessData(): ResolvingProcessDataDto;
    getLineupId(): string;
    getEntryId(): string;
}

class LineupResolvingPrecessImp implements LineupResolvingPrecess {
    constructor(private processData: ResolvingProcessDataDto) {}
    getProcessData(): ResolvingProcessDataDto {
        return {...this.processData};
    }
    getLineupId(): string {
        return this.processData.lineupId;
    }
    getEntryId(): string {
        return this.processData.entryId;
    }
}

const dto: ResolvingProcessDataDto = {
    lineupId: '',
    entryId: '',
};

const lineupResolvingProcess = new LineupResolvingPrecessImp(dto);

export default function (state = lineupResolvingProcess, action) {
    if (action.type === Const.SET_LINEUP_RESOLVING_PROCESS_DATA) {
        state = new LineupResolvingPrecessImp(action.data);
    }

    return state;
}
